import React from 'react';
import { Spin } from 'antd';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useValidateEmailQuery } from '../../../app/api/authApiSlice';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId') ?? '';
  const token = searchParams.get('token') ?? '';

  const { data: result, isSuccess, isError } = useValidateEmailQuery({ userId, token });

  if (isSuccess && result === true) return <Navigate to='/login?verified=true' />;
  if (isError) return <Navigate to='/verify-email-failed' />;

  return <Spin>Verifying email...</Spin>;
};

export default VerifyEmail;
